import { fetchWithAuth } from '@shared/utils/auth';
import { backendUrl } from '@shared/constants/urls/appUrls';

export async function hideTweet(tweetId) {
  if (!tweetId) throw new Error("Tweet ID не задан");

  const url = `${backendUrl}/api/forecasters/tweets/hide-tweet/${tweetId}/`;
  const options = {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Ошибка скрытия твита: HTTP ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Ошибка при hideTweet (tweetId: ${tweetId}):`, error);
    throw error;
  }
}

export async function hideTelegramMessage(messageId) {
  if (!messageId) throw new Error("Message ID не задан");

  const url = `${backendUrl}/api/forecasters/telegram/hide-message/${messageId}/`;
  const options = {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Ошибка скрытия сообщения Telegram: HTTP ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Ошибка при hideTelegramMessage (messageId: ${messageId}):`, error);
    throw error;
  }
}
